export const SkuCategoryNameToProductLineMap = {
  MARKETING_PRODUCTS: {
    freeHighlightedProduct: 'marketing-hub-free',
    paidHighlightedProducts: ['marketing-hub-starter', 'marketing-hub-professional', 'marketing-hub-enterprise'],
    upgradeProduct: 'marketing'
  },
  SALES_PRODUCTS: {
    freeHighlightedProduct: 'sales-hub-free',
    paidHighlightedProducts: ['sales-hub-starter', 'sales-hub-professional', 'sales-hub-enterprise'],
    upgradeProduct: 'sales'
  },
  SERVICE_HUB_PRODUCTS: {
    freeHighlightedProduct: 'service-hub-free',
    paidHighlightedProducts: ['service-hub-starter', 'service-hub-professional', 'service-hub-enterprise'],
    upgradeProduct: 'service'
  },
  CMS_HUB_PRODUCTS: {
    freeHighlightedProduct: 'cms-hub-free',
    paidHighlightedProducts: ['cms-hub-starter', 'cms-hub-professional', 'cms-hub-enterprise'],
    upgradeProduct: 'cms-professional'
  },
  OPERATIONS_HUB_PRODUCTS: {
    freeHighlightedProduct: 'operations-hub-free',
    paidHighlightedProducts: ['operations-hub-starter', 'operations-hub-professional', 'operations-hub-enterprise'],
    upgradeProduct: 'operations-starter'
  }
};
export const getHighlightedProductsForSkuCategory = ({
  skuCategoryName
}) => {
  const productsMetadata = SkuCategoryNameToProductLineMap[skuCategoryName];
  const paidHighlightedProducts = productsMetadata === null || productsMetadata === void 0 ? void 0 : productsMetadata.paidHighlightedProducts;
  const freeHighlightedProduct = productsMetadata === null || productsMetadata === void 0 ? void 0 : productsMetadata.freeHighlightedProduct;
  return {
    paidHighlightedProducts,
    freeHighlightedProduct
  };
};